import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  user: {},
  token: {}
}

const store = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}

export default store
